// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"2c4d31eb","253":"2c4d31eb","368":"2c4d31eb","524":"2c4d31eb","569":"2c4d31eb","622":"2c4d31eb","682":"2c4d31eb","883":"dd5fa1d1","923":"2c4d31eb"}[chunkId] + ".chunk.css";
};